import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

export type Settings = {
    atlas_enabled?: boolean;
}

export function useGetSettings() {
    return useFetch<Settings>(getAbsoluteServerUrl('/settings'), { responseType: 'json' }, [])
}
